import React from 'react';

class ChannelLogo extends React.Component {
  
  render () {
    return (
              <div className="channelLogo" style={this.props.styles} >
                <img style={this.props.imgStyle} src={this.props.logoUrl} alt='logo'/>
              </div>
           );
  }

}

export default ChannelLogo;